import { render, staticRenderFns } from "./FavoriteFeed.vue?vue&type=template&id=a07dc188&scoped=true&"
import script from "./FavoriteFeed.vue?vue&type=script&lang=js&"
export * from "./FavoriteFeed.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteFeed.vue?vue&type=style&index=0&id=a07dc188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07dc188",
  null
  
)

export default component.exports